import gql from 'graphql-tag'

export const topicClusterTitleQuery = gql`
  query TopicClusterTitle($topicClusterSlug: String!, $lang: [Locale!]!, $stage: Stage!) {
    topicCluster(where: { slug: $topicClusterSlug } locales: $lang stage: $stage) {
      slug
      stage

      title
    }
  }
`

export const FullTopicClusterFragment = gql`
  fragment FullTopicCluster on TopicCluster {
    id
    slug
    stage

    title
    teaser
    ctaLabel

    topicClusterHotspots {
      slug

      title
      text
    }

    topics {
      id
      slug
      stage

      title
    }
  }
`

export default gql`
  query TopicCluster($topicClusterSlug: String!, $lang: [Locale!]!, $stage: Stage!) {
    topicCluster(where: { slug: $topicClusterSlug } locales: $lang stage: $stage) {
      ...FullTopicCluster
    }
  }
  ${FullTopicClusterFragment}
`



// WEBPACK FOOTER //
// ./src/queries/topicCluster.js